import { render, staticRenderFns } from "./PostPreviewList.vue?vue&type=template&id=bf83be66&scoped=true&"
import script from "./PostPreviewList.vue?vue&type=script&lang=js&"
export * from "./PostPreviewList.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PostPreviewList.vue?vue&type=style&index=0&id=bf83be66&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "bf83be66",
  "17a4fc1e"
  
)

export default component.exports